const WORDS = ["High shine", "Deep hydration", "Non-sticky feel", "Nude · Brown · Pink", "Made for every skin tone", "Gift-ready"];

export function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="bg-[#281715] text-[#FAF7F2] py-6 overflow-hidden border-y border-[#4A2E2B]" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`font-display text-3xl sm:text-4xl px-8 ${i % 2 ? "italic text-[#EBB1B6]" : ""}`}>{w}</span>
                <svg viewBox="0 0 20 20" className="w-4 h-4 text-[#EBB1B6]"><path fill="currentColor" d="M10 0c1 6 4 9 10 10-6 1-9 4-10 10-1-6-4-9-10-10 6-1 9-4 10-10z" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
